import { render } from "./BardBotSettings.vue?vue&type=template&id=6c0f01d1"
import script from "./BardBotSettings.vue?vue&type=script&lang=js"
export * from "./BardBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__